import api from "@/configs/axios-config";

export type MaterialBasePrice = {
  year: number;
  material_type: {
    id: number;
    material_type_name: string;
  };
  specs: Array<{
    id: number;
    spec_name: string;
  }>;
  suppliers: Array<{
    id: number;
    name_abbr: string;
  }>;
  base_prices: Array<{
    quarter: number;
    data: Array<{
      material_base_price_id: number;
      year: number;
      quarter: number;
      material_supplier_id: number;
      material_spec_id: number;
      base_price: number;
    }>;
  }>;
};

export type getMaterialBasePricesParams = {
  year?: number;
  quarter?: number;
  material_type_id?: number;
};

export const getMaterialBasePricesByYear = async (
  params: getMaterialBasePricesParams
): Promise<MaterialBasePrice> => {
  const response = await api.get(`/material-base-prices/year/${params.year}`, {
    params,
  });
  return response.data;
};

export type UpdateBasePriceBody = {
  prices: Array<{
    material_base_price_id: number;
    base_price: number;
  }>;
  is_buyer_flagged: boolean;
};

export const updateMaterialBasePrices = async (data: UpdateBasePriceBody) => {
  const response = await api.post("/material-base-prices/update", data);
  return response.data;
};

export type CreateQuarterBody = {
  material_type_id: number;
  target_year: number;
  target_quarter: number;
};

export const createNewQuarterBasePrices = async (params: CreateQuarterBody) => {
  const response = await api.post(`/material-base-prices/create-new-quarter`, params);
  return response.data;
};